// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_vxZ","cls2":"ReportList-cls2_poA ReportList-cls1_vxZ"};